var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { connect } from 'react-redux';
import styles from './css/schedule.module.css';
import { Calendar } from 'react-calendar';
import { Link, withRouter } from "react-router-dom";
import * as serviceEventSliceActions from '../store/slices/serviceEventSlice';
import * as appSliceActions from '../store/slices/AppSlice';
var Schedule = /** @class */ (function (_super) {
    __extends(Schedule, _super);
    function Schedule(props) {
        var _this = _super.call(this, props) || this;
        _this.onCalendarChange = function (date) {
            console.log('schedule change');
            _this.setState(function () { return ({ scheduleDate: date }); });
        };
        _this.onChange = function (e) {
            if (e.target.name === "scheduleNotes") {
                _this.setState({ scheduleNotes: e.target.value });
            }
            ;
        };
        _this.saveSchedule = function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                e.preventDefault();
                // save to global state
                this.props.dispatch(serviceEventSliceActions.saveSchedule(__assign(__assign({}, this.props.scheduleState), { scheduleDate: this.state.scheduleDate.toLocaleDateString(), scheduleNotes: this.state.scheduleNotes, availability: this.state.availability })));
                this.props.history.push('/activation/contact');
                return [2 /*return*/];
            });
        }); };
        _this.componentDidMount = function () {
            _this.props.dispatch(appSliceActions.setTimeLineStep(4));
            if (_this.props.scheduleState && _this.props.scheduleState.scheduleDate) {
                _this.setState({
                    scheduleDate: new Date(_this.props.scheduleState.scheduleDate),
                    scheduleNotes: _this.props.scheduleState.scheduleNotes,
                    availability: _this.props.scheduleState.availability
                });
            }
            console.log('schedule mount');
        };
        _this.onTimeChange = function (e) {
            console.log("set availability to " + e.target.value);
            var avail = e.target.value;
            _this.setState(function () { return ({ availability: avail }); });
        };
        _this.state = {
            scheduleDate: new Date(),
            minDate: new Date(),
            scheduleNotes: '',
            availability: ''
        };
        return _this;
    }
    Schedule.prototype.render = function () {
        var weekday = new Array(7);
        weekday[0] = "Sunday";
        weekday[1] = "Monday";
        weekday[2] = "Tuesday";
        weekday[3] = "Wednesday";
        weekday[4] = "Thursday";
        weekday[5] = "Friday";
        weekday[6] = "Saturday";
        var month = ['January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ];
        return (React.createElement("div", { className: styles.scheduleHolder },
            React.createElement("main", { className: styles.schedulingMain },
                React.createElement("h2", null, "When is the best time for your Tempest Expert to visit your home?"),
                React.createElement("form", { action: "", onSubmit: this.saveSchedule },
                    React.createElement("div", { className: styles.schedulingContent },
                        React.createElement("div", { className: styles.loadingPanel, style: this.state.scheduleDate ? { display: 'none' } : { display: 'none' } },
                            React.createElement("div", { className: styles.loadingInfo },
                                React.createElement("h3", null, "Loading schedule..."))),
                        React.createElement("section", { className: styles.row },
                            React.createElement(Calendar, { className: styles.scheduleCalendar, calendarType: "US", minDate: this.state.minDate, onChange: this.onCalendarChange, value: this.state.scheduleDate }),
                            React.createElement("div", { className: styles.timeBlock },
                                React.createElement("h5", null, "Time of Day"),
                                React.createElement("ul", { className: styles.radioButtons },
                                    React.createElement("li", { className: styles.flexRadio },
                                        React.createElement("input", { id: "radio1", name: "time", value: "Morning", checked: this.state.availability === 'Morning', onChange: this.onTimeChange, type: "radio" }),
                                        React.createElement("label", { htmlFor: "radio1" }, "Morning (8am-11am)")),
                                    React.createElement("li", { className: styles.flexRadio },
                                        React.createElement("input", { id: "radio2", name: "time", value: "Afternoon", checked: this.state.availability === 'Afternoon', onChange: this.onTimeChange, type: "radio" }),
                                        React.createElement("label", { htmlFor: "radio2" }, "Afternoon (1pm-4pm)")),
                                    React.createElement("li", { className: styles.flexRadio },
                                        React.createElement("input", { id: "radio4", name: "time", value: "Either", checked: this.state.availability === 'Either', onChange: this.onTimeChange, type: "radio" }),
                                        React.createElement("label", { htmlFor: "radio4" }, "Anytime (8am-4pm)"))))),
                        React.createElement("section", { className: styles.schedulingContentExtra },
                            React.createElement("label", null, "Special Instructions?"),
                            React.createElement("textarea", { onChange: this.onChange, value: this.state.scheduleNotes, name: "scheduleNotes", required: true, rows: 2 }),
                            React.createElement("p", null, "*Someone 18 years or older must be present during the in in-home installation"))),
                    React.createElement("div", { className: "row-right" },
                        React.createElement(Link, { to: "/activation/mount" },
                            React.createElement("span", { className: "btn" }, "Back")),
                        React.createElement("button", { type: "submit", value: "Submit" }, "Next"))))));
    };
    return Schedule;
}(React.Component));
function mapStateToProps(state) {
    return {
        serviceEventId: state.serviceEvent.serviceEventId,
        scheduleState: state.serviceEvent.schedule
    };
}
export default withRouter(connect(mapStateToProps)(Schedule));
